import clsx from 'clsx'
import { useMemo, type FunctionComponent } from 'react'
import { Rating } from '../shared/Rating'
import style from './CheckboxRegular.module.sass'

type CheckboxRegularProps = {
	name?: string
	label: string
	onChange?: React.ChangeEventHandler<HTMLInputElement>
	disabled?: boolean
	checked?: boolean
	defaultChecked?: boolean
	noMargin?: boolean
	count?: number
}

export const CheckboxRegular: FunctionComponent<CheckboxRegularProps> = ({
	name,
	label,
	onChange,
	disabled,
	defaultChecked,
	checked,
	count,
	noMargin = false,
}) => {
	const starLabel = typeof label === 'string' && /^\*+$/g.test(label)

	const visibleLabel = useMemo(() => {
		if (starLabel) {
			return <Rating rateAmount={label.length * 20} hideText disabled={disabled} />
		}
		return label
	}, [label, starLabel, disabled])
	return (
		<div className={clsx(style.root, disabled && style.rootDisabled, noMargin && style.rootNoMargin)}>
			<label
				className={clsx(style.container, noMargin && style.containerNoMargin, disabled && style.containerDisabled)}
			>
				<input
					name={name}
					className={clsx(style.checkbox, disabled && style.checkboxDisabled)}
					type="checkbox"
					checked={checked}
					onChange={onChange}
					disabled={disabled}
					defaultChecked={defaultChecked}
				/>
				<span className={clsx(style.checkmark, disabled && style.checkmarkDisabled)} />
				<span className={clsx(style.label, starLabel && style.labelStars)}>
					{visibleLabel} {typeof count === 'number' && <CountIndicator count={count} disabled={disabled} />}
				</span>
			</label>
		</div>
	)
}

export function CountIndicator({ count, disabled }: { count?: number; disabled?: boolean }) {
	return <small className={clsx(style.count, disabled && style.countDisabled)}>{count}</small>
}
